import MaintenanceGif from '../../assets/image/Maintenance.gif'
import Maintenancetoplogo from '../../assets/image/Maintenancetoplogo.png'
import Maintenancebottomlft from '../../assets/image/Maintenancebottomlft.png'
import Maintenancebottomrgt from '../../assets/image/Maintenancebottomrgt.png'
import React from 'react';

const MaintenancePage = () => {
    return (
        <div className="maintenance-container">
            <div className='maintenanace-top-logo'>
                <img src={Maintenancetoplogo} alt='Maintenance'></img>
            </div>
            <div className='maintenanace-bottom-lft'>
                <img src={Maintenancebottomlft} alt='Maintenance'></img>
            </div>
            <div className='maintenanace-bottom-rgt'>
                <img src={Maintenancebottomrgt} alt='Maintenance'></img>
            </div>
            <div class="maintenance-inner-container">
                <div class="maintenance-content-container ">
                    <div class="maintenance-left-content">
                        <h2>Website is Under</h2>
                        <h1>MAINTENANCE</h1>
                        <p className='text-wrap'>Our website is currently undergoing scheduled maintenance.
                            It should be back shortly. Thank you for your patience.</p>
                    </div>
                    <div class="maintenance-right-gif"><img src={MaintenanceGif} alt='Maintenance'>
                    </img>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MaintenancePage;
